/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalAuthSubmissionStatus = {
    InputNeeded: 'input_needed',
    Review: 'review',
    Submitted: 'submitted',
    Failed: 'failed',
    Pending: 'pending',
    Denied: 'denied',
    PeerToPeer: 'peer_to_peer',
    Approved: 'approved',
    Expired: 'expired',
    PartiallyApproved: 'partially_approved',
    Cancelled: 'cancelled',
    InfoNeeded: 'info_needed',
    SubmissionInProgress: 'submission_in_progress'
} as const;
export type PalAuthSubmissionStatus = typeof PalAuthSubmissionStatus[keyof typeof PalAuthSubmissionStatus];


export function PalAuthSubmissionStatusFromJSON(json: any): PalAuthSubmissionStatus {
    return PalAuthSubmissionStatusFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatus {
    return json as PalAuthSubmissionStatus;
}

export function PalAuthSubmissionStatusToJSON(value?: PalAuthSubmissionStatus | null): any {
    return value as any;
}

